<template>
	<modal
		:exibir="exibir"
		titulo="Concluir Adesão"
		max-width="400"
		:custom-actions="false"
		:acao-cancelar="fecharModal"
		@close="fecharModal"
		:acao-confirmar="confirmar"
		nome-botao-confirmar="Concluir"
		is-confirmar-visivel
		:permissao-confirmar="permissoes.ataAdesaoConcluir"
	>
		<template #body>
			<div class="text-center mt-5">
				<div class="az-text" v-if="possuiItensPendentes">
					Existem itens pendentes na adesão, deseja realmente concluir a adesão?
				</div>
				<div class="az-text" v-else>Deseja realmente concluir a adesão?</div>
			</div>
		</template>
	</modal>
</template>
<script>
import Modal from '@/views/components/Modal.vue'

export default {
	name: 'modal-concluir-adesao',
	components: { Modal },
	props: {
		exibir: {
			type: Boolean,
		},
		possuiItensPendentes: {
			type: Boolean,
		},
	},
	emits: ['concluir'],
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		confirmar() {
			this.$emit('concluir')
		},
	},
}
</script>
